export const STUDY_PLAN_CYCLE_STUDENT_APPROVING_USER_STATUS = {
  SUBMITTED: 'Submitted',
  UNAPPROVED: 'Unapproved',
  RETURNED: 'Returned',
  SUPPLEMENTED: 'Supplemented',
  APPROVED: 'Approved'
};